'use client';
import { createContext } from 'react';

const ModalsContext = createContext(null);
ModalsContext.displayName = "@mantine/modals/ModalsContext";

export { ModalsContext };
//# sourceMappingURL=context.mjs.map
